import React, { PureComponent } from "react";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import "./maintenance.css";
import logo from "../../../img/logo-conga.svg";
import { RELEATIVE_PATH, SF_ICON_PATH } from "../../../config";

import log from "@salesforce/design-system-react/utilities/log";

class Maintenance extends PureComponent<{}, any> {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
        };
    }

    render() {
        return (
            <div class="welcome-background-theme">


                <div class="slds-context-bar">
                    <div class="slds-context-bar__primary">
                        <div class="slds-context-bar__item slds-context-bar__dropdown-trigger slds-dropdown-trigger slds-dropdown-trigger_click slds-no-hover">
                            <div class="slds-context-bar__icon-action">
                                <img alt="Conga Logo" src={logo} />
                            </div>
                            <span class="slds-context-bar__label-action slds-context-bar__app-name">
                                <span class="slds" title="Conga Upgrade">
                                    Welcome to Conga Upgrade
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="wel-cont-div-maintenance container-fluid">

                    <div class="grid-container grid-video">

                        <div class="grid-child div-desc">
                            <h1>Under Maintenance</h1>
                            We are currently undergoing with some planned maintenance activity. <br /> Please come again later.
                        </div>

                        <div class="grid-child">
                            <div class="video-container">
                                <img class="maintenance-img" src={SF_ICON_PATH + "/utility/maintenance.png"} ></img>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

        );
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {};
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(Maintenance));
